import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';

import { Page } from 'ui/components';
import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';

import { Table } from 'services/action';

import useTable from 'ui/components/table';
import tableConfig from './table.config';
import Action from './action';

const initialState = {
  privilege: null,
};

const LocationScreen = () => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const LocationTable = useTable('location', tableConfig);

  const StateTable = useSelector((state) => state?.Table?.data['location']);

  const [{ privilege }, setState] = React.useState(initialState);

  const $getPrivilege = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.location',
    });
    setState((prevState) => ({
      ...prevState,
      privilege: x,
    }));
  };

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  return (
    <Page className="col-12 col-md-8 bordered">
      <Page.Header pretitle="Daftar" title="Lokasi" isLoading={StateLoading}>
        {(!Session?.privileges || privilege?.action === 'manage') && (
          <Action
            onClose={() => Dispatch(Table.$reload('location', StateTable))}
          />
        )}
      </Page.Header>

      <Page.Navigation toolbar>
        <LocationTable.Tools isLoading={StateLoading} downloadable />
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div className="col-md-12 m-0 p-0">
          {StateLoading ? (
            <SkeletonTable headerCount={6} bodyCount={10} />
          ) : (
            <LocationTable.Render />
          )}
        </div>
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <LocationTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default LocationScreen;
